








import {
  onMounted, ref, onUnmounted, computed, defineComponent, Ref, ComputedRef,
} from '@vue/composition-api';
import { ScrollTransitionProps, AnimationMode } from './types';

type AnimationClassNames = [AnimationMode, { enabled: boolean }];

interface ScrollTransitionBindings {
  target: Ref<HTMLElement | undefined>;
  animate: Ref<boolean>;
  animationClass: ComputedRef<AnimationClassNames>;
}

export default defineComponent<ScrollTransitionProps, ScrollTransitionBindings>({
  name: 'ScrollTransition',
  props: {
    animationType: {
      type: String,
      required: false,
      default: AnimationMode.FADE,
    },
    threshold: {
      type: Array,
      required: false,
      default: () => ([0]),
    },
    rootMargin: {
      type: String,
      required: false,
      default: '0px',
    },
  },
  setup(props) {
    const target = ref<HTMLElement>();
    const animate = ref<boolean>(false);
    const animationClass = computed<AnimationClassNames>(() => [
      props.animationType || AnimationMode.FADE,
      { enabled: animate.value },
    ]);
    const options = { root: null, rootMargin: props.rootMargin, threshold: props.threshold };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        animate.value = entry.isIntersecting || entry.boundingClientRect.y < 0;
      });
    }, options);

    onMounted(() => {
      if (target.value) {
        observer.observe(target.value);
      }
    });

    onUnmounted(() => {
      if (target.value) {
        observer.unobserve(target.value);
      }

      observer.disconnect();
    });

    return {
      animate,
      target,
      animationClass,
    };
  },
});
